import { render, staticRenderFns } from "./PrePaidTip.vue?vue&type=template&id=4712f602&scoped=true&"
import script from "./PrePaidTip.vue?vue&type=script&lang=js&"
export * from "./PrePaidTip.vue?vue&type=script&lang=js&"
import style0 from "./PrePaidTip.vue?vue&type=style&index=0&id=4712f602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4712f602",
  null
  
)

export default component.exports